// extracted by mini-css-extract-plugin
export var container = "_s3-0";
export var table = "_s3-2";
export var tableWrapper = "_s3-1";